import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import AnalyticsTab from "./AnalyticsTab";


const AnalyticsTabContainer = ({ subTab }: { subTab?: string }) => {
  const user = useSelector((state: RootState) =>
    state.auth.user);

  return (
    <AnalyticsTab subTab={subTab} user={user} />
  );
};

export default AnalyticsTabContainer;
